import { jsxs as le, jsx as l } from "react/jsx-runtime";
import { c as he } from "react/compiler-runtime";
import { TableBody as ae, TableRow as X, TableCell as O, Skeleton as de, CircularProgress as pe, Box as ce, Typography as xe, Checkbox as be, IconButton as we } from "@mui/material";
import { flexRender as Ce } from "@tanstack/react-table";
import { getHeaderWidths as ye, getGroupDetails as Re, createDragGhost as Se } from "./utils.js";
import De from "@mui/icons-material/KeyboardArrowDown";
import { u as ue, g as Ee } from "../../../chunks/TableContext.js";
import { styles as a } from "./styles.js";
import { useVirtualizer as We } from "@tanstack/react-virtual";
import { useRef as ve, useState as Be, useEffect as ke, useMemo as Fe } from "react";
import { DragIndicator as Ae } from "@mui/icons-material";
function Ke() {
  const {
    table: d,
    isGroupable: e,
    emptyStateComponent: t,
    isLoading: C,
    enableVirtualization: g,
    isDraggable: f,
    enableSelection: E,
    groupByColumns: p = [],
    columnSizing: W
  } = ue(), x = d.getRowModel().rows, c = ve(null), [h, k] = Be({});
  ke(() => {
    if (g) {
      const r = requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const o = ye(d);
          k(o);
        });
      });
      return () => cancelAnimationFrame(r);
    }
  }, [d, g, W]);
  const R = Fe(() => {
    if (g) {
      const o = {};
      return d.getAllColumns().forEach((n) => {
        if (n.id !== "expander" && !n.getIsGrouped()) {
          const i = n.columnDef, u = h[n.id], y = W[n.id];
          o[n.id] = u ?? y ?? i.width ?? "auto";
        }
      }), o;
    }
    const r = {};
    return d.getAllColumns().forEach((o) => {
      if (o.id !== "expander" && !o.getIsGrouped()) {
        const n = o.columnDef, i = W[o.id];
        r[o.id] = i ?? n.width ?? "auto";
      }
    }), r;
  }, [d, g, W, h]), b = We({
    count: x.length,
    getScrollElement: () => {
      if (c.current) {
        if (!c.current.closest('.MuiDialog-container, .MuiDialogContent-root, [role="dialog"], dialog')) {
          const i = document.getElementById("table-container");
          return i || document.body;
        }
        let n = c.current.parentElement;
        for (; n && n !== document.body; ) {
          const i = window.getComputedStyle(n), u = i.overflow === "auto" || i.overflow === "scroll" || i.overflowY === "auto" || i.overflowY === "scroll", y = n.scrollHeight > n.clientHeight, S = i.height !== "auto" && i.height !== "", w = i.maxHeight !== "none" && i.maxHeight !== "";
          if (u && (y || S || w))
            return n;
          n = n.parentElement;
        }
      }
      const r = document.getElementById("table-container");
      return r || document.body;
    },
    estimateSize: () => 52,
    // Initial estimate, will be updated by dynamic measurement
    overscan: 5,
    measureElement: (r) => r?.getBoundingClientRect().height || 52,
    enabled: g
  });
  if (C) {
    const r = d.getAllColumns().filter((n) => n.id !== "expander" && !p?.includes(n.id)), o = [];
    return E && o.push("selection"), f && o.push("drag"), o.push(...r.map((n) => n.id)), /* @__PURE__ */ le(ae, { sx: a.tableBody, ref: c, children: [
      Array.from({
        length: 5
      }).map((n, i) => /* @__PURE__ */ l(X, { sx: a.tableRow, children: o.map((u) => {
        if (u === "selection")
          return /* @__PURE__ */ l(O, { sx: {
            ...a.tableCell,
            borderBottom: "1px solid #EFEFEF",
            width: 48,
            maxWidth: 48,
            minWidth: 48,
            padding: "12px 16px"
          }, children: /* @__PURE__ */ l(de, { variant: "rectangular", width: 16, height: 16 }) }, `skeleton-cell-selection-${i}`);
        if (u === "drag")
          return /* @__PURE__ */ l(O, { sx: {
            ...a.tableCell,
            borderBottom: "1px solid #EFEFEF",
            width: 32,
            maxWidth: 32,
            minWidth: 32,
            padding: "12px 16px"
          }, children: /* @__PURE__ */ l(de, { width: 10, height: 20 }) }, `skeleton-cell-drag-${i}`);
        const S = r.find((v) => v.id === u)?.columnDef, w = R[u] || S?.width;
        return /* @__PURE__ */ l(O, { sx: {
          ...a.tableCell,
          borderBottom: "1px solid #EFEFEF",
          width: w,
          maxWidth: w,
          minWidth: w,
          padding: "12px 16px"
        }, children: /* @__PURE__ */ l(de, { variant: "rectangular", width: i % 2 === 1 ? "50%" : "70%", height: 12, sx: {
          borderRadius: 12
        } }) }, `skeleton-cell-${i}-${u}`);
      }) }, `skeleton-row-${i}`)),
      /* @__PURE__ */ l(X, { children: /* @__PURE__ */ l(O, { colSpan: o.length, sx: {
        border: "none",
        textAlign: "left",
        padding: "16px"
      }, children: /* @__PURE__ */ l(pe, { size: 22, thickness: 5, sx: a.defaultLoadingSpinner }) }) })
    ] });
  }
  if (x.length === 0) {
    const r = f && E ? d.getAllColumns().length + 2 : f || E ? d.getAllColumns().length + 3 : d.getAllColumns().length;
    return /* @__PURE__ */ l(ae, { sx: a.tableBody, ref: c, children: /* @__PURE__ */ l(X, { children: /* @__PURE__ */ l(O, { colSpan: r, sx: a.emptyStateCell, children: t || "No data" }) }) });
  }
  if (g) {
    const r = E && f ? d.getAllColumns().length + 2 : E || f ? d.getAllColumns().length + 1 : d.getAllColumns().length;
    return /* @__PURE__ */ l(ae, { sx: {
      ...a.tableBody,
      ...a.virtualizedTableBody,
      width: "max-content",
      minWidth: "100%"
    }, ref: c, children: /* @__PURE__ */ l(X, { sx: {
      height: `${b.getTotalSize()}px`,
      position: "relative",
      width: "max-content",
      minWidth: "100%"
    }, children: /* @__PURE__ */ l(O, { colSpan: r, sx: {
      height: "100%",
      padding: 0,
      border: "none",
      position: "relative",
      width: "max-content",
      minWidth: "100%"
    }, children: b.getVirtualItems().map((o) => {
      const n = x[o.index];
      if (!n) return null;
      const i = {
        position: "absolute",
        top: `${o.start}px`,
        left: 0,
        width: "max-content",
        minWidth: "100%"
      };
      return e && n.getIsGrouped() ? /* @__PURE__ */ l(X, { "data-index": o.index, ref: (u) => b.measureElement(u), style: i, children: /* @__PURE__ */ l(ge, { row: n, enableVirtualization: g, headerWidths: R }) }, o.key) : /* @__PURE__ */ l(X, { "data-index": o.index, ref: (u) => b.measureElement(u), style: i, component: g ? "div" : "tr", children: /* @__PURE__ */ l(fe, { row: n, isLastRow: o.index === x.length - 1, enableVirtualization: g, headerWidths: R }) }, o.key);
    }) }) }) });
  }
  return /* @__PURE__ */ l(ae, { sx: a.tableBody, children: x.map((r, o) => {
    const n = o === x.length - 1;
    return e && r.getIsGrouped() ? /* @__PURE__ */ l(ge, { row: r, enableVirtualization: g, headerWidths: R }, r.id) : /* @__PURE__ */ l(fe, { row: r, isLastRow: n, enableVirtualization: g, headerWidths: R }, r.id);
  }) });
}
function ge(d) {
  const e = he(82), {
    row: t,
    style: C,
    enableVirtualization: g,
    headerWidths: f
  } = d, {
    table: E,
    expanded: p,
    getColumnById: W,
    handleRowRightClick: x,
    rowSx: c,
    handleRowEnter: h,
    handleRowLeave: k
  } = ue(), R = p === !0 || !!p?.[t.id];
  let b, r, o, n, i, u, y, S, w, v, F, B, z, j, D, V;
  if (e[0] !== g || e[1] !== W || e[2] !== h || e[3] !== k || e[4] !== x || e[5] !== f || e[6] !== R || e[7] !== t || e[8] !== c || e[9] !== C || e[10] !== E) {
    S = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      const {
        nestingLevel: ne,
        groupValue: G,
        groupByColumn: Z
      } = Re(t), q = W(Z), ee = q?.groupRenderer !== void 0, M = q?.hideGroupingValues?.(t) ?? !1, te = q?.hideGroupingRow?.(t) ?? !1;
      let K, L;
      if (e[27] !== g || e[28] !== f || e[29] !== E) {
        L = E.getAllLeafColumns().filter(Le);
        let m;
        e[32] !== g || e[33] !== f ? (m = (ie, oe) => {
          const re = oe.columnDef, se = g && f[oe.id] || re.width;
          return ie + (typeof se == "number" ? se : 0);
        }, e[32] = g, e[33] = f, e[34] = m) : m = e[34], K = L.reduce(m, 0), e[27] = g, e[28] = f, e[29] = E, e[30] = K, e[31] = L;
      } else
        K = e[30], L = e[31];
      const I = K;
      if (te) {
        t.toggleExpanded(!0), S = null;
        break e;
      }
      o = X;
      let $;
      e[35] !== C ? ($ = C || {}, e[35] = C, e[36] = $) : $ = e[36];
      let P;
      e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = {
        backgroundColor: "#ffffff"
      }, e[37] = P) : P = e[37];
      let H;
      e[38] !== t || e[39] !== c ? (H = typeof c == "function" ? c(t.original) : c, e[38] = t, e[39] = c, e[40] = H) : H = e[40], e[41] !== $ || e[42] !== H ? (D = {
        ...a.tableRow,
        ...$,
        ":hover": P,
        ...H
      }, e[41] = $, e[42] = H, e[43] = D) : D = e[43], V = "row", e[44] !== x || e[45] !== t ? (i = (m) => {
        m.preventDefault(), x?.(m, t.original, t.index);
      }, e[44] = x, e[45] = t, e[46] = i) : i = e[46], e[47] !== h || e[48] !== t ? (u = (m) => h?.(m, t.original, t.index), e[47] = h, e[48] = t, e[49] = u) : u = e[49], e[50] !== k || e[51] !== t ? (y = (m) => k?.(m, t.original, t.index), e[50] = k, e[51] = t, e[52] = y) : y = e[52], r = O, F = "left", e[53] !== I ? (B = {
        ...a.groupedRow,
        width: I,
        minWidth: I,
        maxWidth: I,
        boxSizing: "border-box",
        height: "auto"
      }, e[53] = I, e[54] = B) : B = e[54], z = L.length, j = "cell", b = ce;
      const _ = `${ne * 30}px`;
      e[55] !== _ ? (n = {
        ...a.groupedRowContent,
        paddingLeft: _
      }, e[55] = _, e[56] = n) : n = e[56];
      const N = R ? "rotate(180deg)" : "rotate(0deg)", Q = M ? "not-allowed" : "pointer", U = M ? 0.5 : 1;
      let Y;
      e[57] !== N || e[58] !== Q || e[59] !== U ? (Y = {
        ...a.expandButton,
        transform: N,
        cursor: Q,
        opacity: U
      }, e[57] = N, e[58] = Q, e[59] = U, e[60] = Y) : Y = e[60];
      let s;
      e[61] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ l(De, {}), e[61] = s) : s = e[61], w = /* @__PURE__ */ l(we, { onClick: () => !M && t.toggleExpanded(), size: "small", sx: Y, children: s }), v = ee ? q?.groupRenderer?.({
        row: t,
        groupValue: G,
        subRows: t.subRows,
        subRowsCount: t.subRows.length,
        toggleExpanded: () => !M && t.toggleExpanded(),
        isExpanded: R,
        nestingLevel: ne,
        columnId: Z
      }) : /* @__PURE__ */ le(ce, { sx: {
        display: "flex",
        alignItems: "center"
      }, children: [
        G,
        !M && /* @__PURE__ */ le(xe, { variant: "body2", sx: {
          ml: 1
        }, children: [
          "(",
          t.subRows.length,
          ")"
        ] })
      ] });
    }
    e[0] = g, e[1] = W, e[2] = h, e[3] = k, e[4] = x, e[5] = f, e[6] = R, e[7] = t, e[8] = c, e[9] = C, e[10] = E, e[11] = b, e[12] = r, e[13] = o, e[14] = n, e[15] = i, e[16] = u, e[17] = y, e[18] = S, e[19] = w, e[20] = v, e[21] = F, e[22] = B, e[23] = z, e[24] = j, e[25] = D, e[26] = V;
  } else
    b = e[11], r = e[12], o = e[13], n = e[14], i = e[15], u = e[16], y = e[17], S = e[18], w = e[19], v = e[20], F = e[21], B = e[22], z = e[23], j = e[24], D = e[25], V = e[26];
  if (S !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return S;
  let A;
  e[62] !== b || e[63] !== n || e[64] !== w || e[65] !== v ? (A = /* @__PURE__ */ le(b, { sx: n, children: [
    w,
    v
  ] }), e[62] = b, e[63] = n, e[64] = w, e[65] = v, e[66] = A) : A = e[66];
  let T;
  e[67] !== r || e[68] !== A || e[69] !== F || e[70] !== B || e[71] !== z || e[72] !== j ? (T = /* @__PURE__ */ l(r, { align: F, sx: B, colSpan: z, role: j, children: A }), e[67] = r, e[68] = A, e[69] = F, e[70] = B, e[71] = z, e[72] = j, e[73] = T) : T = e[73];
  let J;
  return e[74] !== o || e[75] !== i || e[76] !== u || e[77] !== y || e[78] !== T || e[79] !== D || e[80] !== V ? (J = /* @__PURE__ */ l(o, { sx: D, role: V, onContextMenu: i, onMouseEnter: u, onMouseLeave: y, children: T }), e[74] = o, e[75] = i, e[76] = u, e[77] = y, e[78] = T, e[79] = D, e[80] = V, e[81] = J) : J = e[81], J;
}
function Le(d) {
  return d.id !== "expander" && !d.getIsGrouped();
}
function fe(d) {
  const e = he(91), {
    row: t,
    isLastRow: C,
    style: g,
    enableVirtualization: f,
    headerWidths: E
  } = d, {
    enableSelection: p,
    toggleRowSelection: W,
    isRowSelected: x,
    selectedRows: c,
    isDraggable: h,
    onDragStart: k,
    onDragEnd: R,
    dragLabelColumnId: b,
    dragCountSuffix: r,
    handleRowClick: o,
    handleRowRightClick: n,
    rowSx: i,
    selectedRowIndex: u,
    onRowClick: y,
    handleRowEnter: S,
    handleRowLeave: w,
    isRowSelectionDisabled: v,
    selectedRowId: F
  } = ue(), B = r === void 0 ? "Items" : r;
  let z;
  if (e[0] !== B || e[1] !== b || e[2] !== p || e[3] !== f || e[4] !== o || e[5] !== S || e[6] !== w || e[7] !== n || e[8] !== E || e[9] !== h || e[10] !== C || e[11] !== x || e[12] !== v || e[13] !== R || e[14] !== k || e[15] !== y || e[16] !== t || e[17] !== i || e[18] !== F || e[19] !== u || e[20] !== c || e[21] !== g || e[22] !== W) {
    const j = t.getVisibleCells().filter(Ve);
    let D, V;
    e[24] !== p || e[25] !== x || e[26] !== t.original ? (D = p ? Ee(t.original) : "", V = p ? x(D) : !1, e[24] = p, e[25] = x, e[26] = t.original, e[27] = D, e[28] = V) : (D = e[27], V = e[28]);
    const A = V;
    let T;
    e[29] !== v || e[30] !== t.index || e[31] !== t.original ? (T = v?.(t.original, t.index) ?? !1, e[29] = v, e[30] = t.index, e[31] = t.original, e[32] = T) : T = e[32];
    const J = T, ne = F != null ? F === t.original.id : u === t.index;
    let G;
    if (e[33] !== b || e[34] !== t) {
      if (G = "Moving", b) {
        const s = t.getVisibleCells().find((m) => m.column.id === b)?.getValue();
        s !== void 0 && (G = `${s}`);
      }
      e[33] = b, e[34] = t, e[35] = G;
    } else
      G = e[35];
    let Z;
    e[36] !== B || e[37] !== h || e[38] !== G || e[39] !== k || e[40] !== t.original || e[41] !== c ? (Z = (s) => {
      if (h) {
        const m = c.size > 0 ? Array.from(c).map(ze) : [t.original];
        s.dataTransfer.setData("application/json", JSON.stringify(m)), Se(s, G, c.size, B), k?.(s, m);
      }
    }, e[36] = B, e[37] = h, e[38] = G, e[39] = k, e[40] = t.original, e[41] = c, e[42] = Z) : Z = e[42];
    let q;
    e[43] !== h || e[44] !== R || e[45] !== t.original || e[46] !== c ? (q = (s) => {
      if (h) {
        const m = c.size > 0 ? Array.from(c).map(Ie) : [t.original];
        R?.(s, m);
      }
    }, e[43] = h, e[44] = R, e[45] = t.original, e[46] = c, e[47] = q) : q = e[47];
    let ee;
    e[48] !== o || e[49] !== t.index || e[50] !== t.original ? (ee = (s) => o?.(s, t.original, t.index, t.original.id), e[48] = o, e[49] = t.index, e[50] = t.original, e[51] = ee) : ee = e[51];
    let M;
    e[52] !== n || e[53] !== t.index || e[54] !== t.original ? (M = (s) => {
      s.preventDefault(), n?.(s, t.original, t.index);
    }, e[52] = n, e[53] = t.index, e[54] = t.original, e[55] = M) : M = e[55];
    let te;
    e[56] !== S || e[57] !== t.index || e[58] !== t.original ? (te = (s) => S?.(s, t.original, t.index), e[56] = S, e[57] = t.index, e[58] = t.original, e[59] = te) : te = e[59];
    let K;
    e[60] !== w || e[61] !== t.index || e[62] !== t.original ? (K = (s) => w?.(s, t.original, t.index), e[60] = w, e[61] = t.index, e[62] = t.original, e[63] = K) : K = e[63];
    let L;
    e[64] !== g ? (L = g || {}, e[64] = g, e[65] = L) : L = e[65];
    let I;
    e[66] !== f ? (I = f ? {
      display: "flex",
      width: "max-content",
      minWidth: "100%"
    } : {}, e[66] = f, e[67] = I) : I = e[67];
    const $ = y ? "pointer" : "default", P = A || ne ? "#e5f3f0" : "#ffffff", H = A || ne ? "#e5f3f0" : "#F8F8F8";
    let _;
    e[68] !== H ? (_ = {
      backgroundColor: H
    }, e[68] = H, e[69] = _) : _ = e[69];
    let N;
    e[70] !== t.original || e[71] !== i ? (N = typeof i == "function" ? i(t.original) : i, e[70] = t.original, e[71] = i, e[72] = N) : N = e[72];
    let Q;
    e[73] !== L || e[74] !== I || e[75] !== $ || e[76] !== P || e[77] !== _ || e[78] !== N ? (Q = {
      ...a.tableRow,
      ...L,
      ...I,
      cursor: $,
      backgroundColor: P,
      ":hover": _,
      ...N
    }, e[73] = L, e[74] = I, e[75] = $, e[76] = P, e[77] = _, e[78] = N, e[79] = Q) : Q = e[79];
    let U;
    e[80] !== p || e[81] !== J || e[82] !== C || e[83] !== A || e[84] !== D || e[85] !== W ? (U = p && /* @__PURE__ */ l(O, { sx: {
      ...a.tableCell,
      ...a.bodySelectionCell,
      borderBottom: C ? "none" : "1px solid #EFEFEF"
    }, children: /* @__PURE__ */ l(be, { checked: A, disabled: J, onChange: () => !J && W(D), sx: a.checkbox }) }), e[80] = p, e[81] = J, e[82] = C, e[83] = A, e[84] = D, e[85] = W, e[86] = U) : U = e[86];
    let Y;
    e[87] !== p || e[88] !== h || e[89] !== C ? (Y = h && /* @__PURE__ */ l(O, { sx: {
      ...a.tableCell,
      ...a.bodyDragCell,
      ...p ? {} : a.bodyDragCellNoSelection,
      ...C ? a.bodyCellLastRow : {}
    }, children: /* @__PURE__ */ l(ce, { sx: a.dragIndicatorContainer, children: /* @__PURE__ */ l(Ae, { sx: a.dragIndicator }) }) }), e[87] = p, e[88] = h, e[89] = C, e[90] = Y) : Y = e[90], z = /* @__PURE__ */ le(X, { component: f ? "div" : "tr", draggable: h, onDragStart: Z, onDragEnd: q, onClick: ee, onContextMenu: M, onMouseEnter: te, onMouseLeave: K, sx: Q, role: "row", children: [
      U,
      Y,
      t.getVisibleCells().map((s) => {
        const m = s.column.columnDef, ie = E[s.column.id] ?? m.width ?? "auto", oe = j.findIndex((me) => me.column.id === s.column.id), re = oe === 0, se = oe === j.length - 1;
        return s.column.id !== "expander" && !s.column.getIsGrouped() && /* @__PURE__ */ l(O, { component: f ? "div" : "td", align: "left", sx: {
          ...a.tableCell,
          ...a.bodyCell,
          width: ie,
          maxWidth: m.maxWidth || ie,
          minWidth: m.minWidth || ie,
          ...f ? {
            flex: "0 0 auto"
          } : {},
          ...re && !p && !h ? a.bodyCellFirst : {},
          ...se ? a.bodyCellLast : {},
          ...C ? a.bodyCellLastRow : {}
        }, role: "cell", children: Ce(s.column.columnDef.cell, s.getContext()) }, s.id);
      })
    ] }), e[0] = B, e[1] = b, e[2] = p, e[3] = f, e[4] = o, e[5] = S, e[6] = w, e[7] = n, e[8] = E, e[9] = h, e[10] = C, e[11] = x, e[12] = v, e[13] = R, e[14] = k, e[15] = y, e[16] = t, e[17] = i, e[18] = F, e[19] = u, e[20] = c, e[21] = g, e[22] = W, e[23] = z;
  } else
    z = e[23];
  return z;
}
function Ie(d) {
  return JSON.parse(d);
}
function ze(d) {
  return JSON.parse(d);
}
function Ve(d) {
  return d.column.id !== "expander" && !d.column.getIsGrouped();
}
export {
  Ke as TableBody
};
